export default __webpack_public_path__ + "static/media/infro icon 2.83a4aa8c.svg";